import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextLabel, { SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'

const HighlightText = ({ children, isHighlighted }) => {
  let size = SizeType.XXTINY
  let weight = WeightType.LIGHT

  if (isHighlighted) {
    size = SizeType.XTINY
    weight = WeightType.NORMAL
  }

  return (
    <TextLabel size={size} weight={weight}>
      {children}
    </TextLabel>
  )
}

HighlightText.propTypes = {
  children: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired
}

HighlightText.defaultProps = {
  isHighlighted: false
}

export default compose(pure)(HighlightText)
